import { Cacheable, CacheBuster } from 'ts-cacheable';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ChannelCategoryList } from 'src/app/channel/model/channelCategoryList';
import { ChannelCategoryEdit } from 'src/app/channel/model/channelCategoryEdit';

const channelCategoriesCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class ChannelCategoryService
{
  constructor(private http: HttpClient) { }

  /**
   * Get full Channel Categories object.
   */
  @Cacheable(
    {
      cacheBusterObserver: channelCategoriesCacheBuster
    })
  public getCachedChannelCategories(activeOnly = false): Observable<ChannelCategoryList[]>
  {
    return this.http.get<ChannelCategoryList[]>('/channels/categories?activeonly=' + activeOnly);
  }

  /**
   * Delete a Channel Category.
   *
   * @param id Channel Cateogry id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: channelCategoriesCacheBuster
    })
  public deleteChannelCategory(id: number): Observable<ChannelCategoryList>
  {
    return this.http.delete<ChannelCategoryList>(`/channels/category/${id}`);
  }

  /**
   * Save a Channel Category.
   *
   * @param data Channel Category to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: channelCategoriesCacheBuster
    })
  public saveChannelCategory(data: ChannelCategoryEdit, isNew: boolean, channelCategoryId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/channels/category', data);
    }
    else
    {
      return this.http.put(`/channels/category/${channelCategoryId}`, data);
    }
  }

  /**
   * Get Channel Categories for grid list.
   */
  public getChannelCategoriesList(): Observable<ChannelCategoryList[]>
  {
    return this.http.get<ChannelCategoryList[]>('/channels/categories/list');
  }

  /**
   * Get full Channel Categories object.
   */
  public getChannelCategories(activeOnly = false): Observable<ChannelCategoryList[]>
  {
    return this.http.get<ChannelCategoryList[]>(`/channels/categories?activeonly=${activeOnly}`);
  }

  /**
   * Get Channel Category by id.
   *
   * @param id Channel Category id
   */
  public getChannelCategoryById(id: number): Observable<ChannelCategoryEdit>
  {
    return this.http.get<ChannelCategoryEdit>(`/channels/category/${id}`);
  }

  /**
   * Check if Channel Category is in use
   *
   * @param id Channel Category Id
   */
  public existsChannelCategory(id: number): Observable<any>
  {
    return this.http.get(`/channels/category/inuse/${id}`);
  }

  /**
   * Check if Channel Category Name exists to avoid name duplicates
   *
   * @param name Channel Category Name
   */
  public existsChannelCategoryName(name: string): Observable<any>
  {
    return this.http.get(`/channels/category/exists?name=${name}`);
  }

  public referralChannelUsedForCommunityService(channelId: number): Observable<any>
  {
    return this.http.get(`/channels/${channelId}/referral`);
  }  
}
